import { unsetAll } from "@otto-ec/global-resources/event";
import { on } from "svelte/events";

/**
 *
 *
 *
 *
 *
 *
 */
export const unmaskElement = (element: HTMLElement, ev: Event): void => {
  const maskedRef = element.dataset.maskedRef;
  if (!maskedRef) return;

  const decodedHref = atob(maskedRef);

  /*                                                                            */
  if (element instanceof HTMLAnchorElement) {
    element.href = decodedHref;
    delete element.dataset.maskedRef;
    return;
  }

  /*                                                                      */
  const anchorElement = document.createElement("a");

  /*                                                                      */
  Array.from(element.attributes)
    .filter((attr) => attr.name !== "data-masked-ref")
    .forEach(({ name, value }) => {
      anchorElement.setAttribute(name, value);
    });

  /*                                                                               */
  /*                                           */
  anchorElement.__ocAutoAriaLabel = element.__ocAutoAriaLabel;

  /*                                                              */
  anchorElement.href = decodedHref;

  /*                                                  */
  anchorElement.append(...element.childNodes);

  /*                                                                      */
  element.parentNode?.replaceChild(anchorElement, element);

  /*                                                                 */
  if (ev instanceof FocusEvent && ev.target === element) {
    ev.preventDefault();
    ev.stopPropagation();
    anchorElement.focus();
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useMaskedLink = (actionElement: () => HTMLElement | undefined): void => {
  $effect(() => {
    const element = actionElement();
    if (!element) return;

    if (!element.dataset.maskedRef) return;

    /*                                                                                */
    if (!element.hasAttribute("tabindex")) element.tabIndex = 0;
    if (!element.role) element.role = "link";

    /*                                                               */
    return unsetAll(
      ...["focusin", "mouseover", "touchstart"].map((eventName) =>
        on(element, eventName, (ev) => unmaskElement(element, ev), {
          passive: true,
          once: true,
        }),
      ),
    );
  });
};
